var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 2.94922V11.2826C18.3307 11.8351 18.1112 12.365 17.7205 12.7557C17.3298 13.1464 16.7999 13.3659 16.2474 13.3659H3.7474C3.19486 13.3659 2.66496 13.1464 2.27426 12.7557C1.88356 12.365 1.66406 11.8351 1.66406 11.2826V2.94922",
    stroke: "#5E5E62",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 2.94954C18.3307 2.39701 18.1112 1.86711 17.7205 1.47641C17.3298 1.0857 16.7999 0.866211 16.2474 0.866211H3.7474C3.19486 0.866211 2.66496 1.0857 2.27426 1.47641C1.88356 1.86711 1.66406 2.39701 1.66406 2.94954L8.89323 7.46343C9.22434 7.67038 9.60694 7.7801 9.9974 7.7801C10.3879 7.7801 10.7705 7.67038 11.1016 7.46343L18.3307 2.94954Z",
    stroke: "#5E5E62",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.f55fe68aafcbe8473df0d4f4e633ac3c.svg";
export { ForwardRef as ReactComponent };